/* Burbuja Marina — animaciones de scroll */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var items = document.querySelectorAll('.bm-reveal:not(.bm-in)');
    if (!items.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('bm-in'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('bm-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    items.forEach(function (el) {
      if (!el.style.getPropertyValue('--bm-delay')) {
        var group = el.closest('[data-bm-stagger]');
        if (group) {
          var siblings = Array.prototype.slice.call(group.querySelectorAll('.bm-reveal'));
          var idx = siblings.indexOf(el);
          if (idx > -1) el.style.setProperty('--bm-delay', (idx * 0.09).toFixed(2) + 's');
        }
      }
      observer.observe(el);
    });
  }

  function initParallax() {
    if (reduced) return;
    var layers = document.querySelectorAll('[data-bm-parallax]');
    if (!layers.length) return;

    var ticking = false;

    function update() {
      var vh = window.innerHeight;
      layers.forEach(function (el) {
        var box = (el.parentElement || el).getBoundingClientRect();
        if (box.bottom < -150 || box.top > vh + 150) return;
        var speed = parseFloat(el.getAttribute('data-bm-parallax')) || 0.18;
        var center = box.top + box.height / 2 - vh / 2;
        el.style.transform = 'translateY(' + (center * -speed).toFixed(1) + 'px) scale(1.12)';
      });
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  function init() {
    initReveals();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-inicializa cuando el editor de Shopify recarga una sección */
  document.addEventListener('shopify:section:load', init);
})();
